import { render, staticRenderFns } from "./EstimateDetail.vue?vue&type=template&id=1f1c9452&scoped=true"
import script from "./EstimateDetail.vue?vue&type=script&lang=js"
export * from "./EstimateDetail.vue?vue&type=script&lang=js"
import style0 from "./EstimateDetail.vue?vue&type=style&index=0&id=1f1c9452&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c9452",
  null
  
)

export default component.exports